/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getConversationList} from '../api'

 export const useQueryGetConversationList = createReactQueryHook('getConversationList', getConversationList)
